import { render, staticRenderFns } from "./portArchiveContacts.vue?vue&type=template&id=2ee9d356"
import script from "./portArchiveContacts.vue?vue&type=script&lang=js"
export * from "./portArchiveContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports